module.exports = __webpack_public_path__ + "img/garota-apresentacao-old.de335eee.png";